import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { eve, eve_page, eve_count, backend } from '../../components/apipath';
import { switchHelper, dateHelper } from "../../modules/helpers";

function EvaRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);

    // 讀取點數申請記錄
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const response = await axios.get(`${eve_page(page - 1, rows)}`, { headers: { token } });
            const data = response.data;
            console.log("Response Data (fetchData):", data); 
            setRequestList(data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };
    


    const fetchPageData = async () => {
        try {
            const response = await axios.get(`${eve_count}`, { headers: { token } });
            console.log("Response Data (fetchPageData):", response.data);
            if (response.data && response.data[0]) {
                setRowsCount(response.data[0].total || 0);
            }
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);
    
    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    
    // 開始編輯
    const startEditing = (requestList) => {
        setEditingRequest(requestList);
        setUpdatedData(requestList);
    };

    // const formatToMysqlDatetime = (dateInput) => {
    //     const date = new Date(dateInput);
    //     const pad = (n) => (n < 10 ? '0' + n : n);
    //     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    //            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    // };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        
        let finalValue;
        if (type === 'checkbox') {
            finalValue = switchHelper(checked);
        } else if (type === 'number') {
            finalValue = value === '' ? '' : parseInt(value, 10);
        } else if (name === "e_material") {
            finalValue = value === "true";
        } else {
            finalValue = value;
        }
    
        setUpdatedData(prevData => ({
            ...prevData,
            [name]: finalValue
        }));
    };
    
    const getSSNLabel = (value) => {
        switch (value) {
          case 0:
          case "0":
            return "有";
          case 1:
          case "1":
            return "沒有";
        }
      };

    const getOccupationLabel = (value) => {
        switch (value) {
          case 1:
          case "1":
            return "在學生";
          case 2:
          case "2":
            return "在職者";
          case 3:
          case "3":
            return "待業中";
          case 4:
          case "4":
            return "服役中";
          default:
            return "未填寫";
        }
      };

      const getExperienceLabel = (value) => {
        switch (value) {
          case 1:
          case "1":
            return "否";
          case 2:
          case "2":
            return "1年以內";
          case 3:
          case "3":
            return "1-3年";
          case 4:
          case "4":
            return "3-5年";
          case 5:
          case "5":
            return "5年以上";
          default:
            return "未填寫";
        }
      };

      const industryMap = {
        accounting_firm: "會計事務所",
        law_firm: "法律事務所",
        banking: "銀行相關",
        financial_consulting: "金融投顧",
        manufacturing: "製造相關",
        ecommerce: "電子商務",
        biotechnology: "生物科技",
        software_engineering: "資訊工程",
        consulting_services: "顧問服務",
        other: "其他"
      };

      const getIndustryLabel = (value) => industryMap[value] || "未填寫";

      const purposeMap = {
        cpa_exam: "抵免台灣會計師考試",
        foreign_company: "進外商公司",
        career_competition: "增加職場競爭力",
        promotion: "升遷、加薪籌碼",
        practice_demand: "執業需求",
        study_abroad: "計劃一年內出國留學",
        immigration: "計畫移民",
      };
      
      const getPurposeLabels = (purposes) => {
        if (!purposes) return [];
        const values = Array.isArray(purposes) ? purposes : purposes.split(',');
      
        return values.map((value) => {
          if (value.startsWith("other:")) {
            return `其他：${value.slice(6)}`;
          }
          return purposeMap[value] || "未知目的";
        }).join("、"); // 用頓號分隔顯示
      };


    // 更新申請記錄
    const saveChanges = async () => {
        try {
            const dataToSend = {
                eva_id: updatedData.eva_id,
                status: updatedData.status || '審核中',
            };
    
            console.log("✅ 更新送出的資料:", dataToSend);
    
            const response = await axios.put(`${eve}`, dataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token
                  }
            });
    
            setRequestList(prevList =>
                prevList.map(req =>
                    req.eva_id === updatedData.eva_id ? response.data : req
                )
            );
    
            // setEditingId(null);
        } catch (error) {
            console.error("更新失敗:", error);
        }
    };
    
    
    
    return (
        <>
            <div className="mt100 container-fluid p-5">
                {loading ? (
                    <p>載入中...</p>
                ) : (
                    <div className="mt-2">
                        <table className="table table-striped border table-responsive">
                            <thead>
                                <tr>
                                    <th>學生姓名</th>
                                    <th>電話</th>
                                    <th>信箱</th>
                                    <th>地區</th>
                                    <th>目前身份</th>
                                    <th>職業類別</th>
                                    <th>財務工作經驗</th>
                                    <th>報考目的</th>
                                    <th>SSN</th>
                                    <th>緣由</th>
                                    <th>成績單檔案</th>
                                    <th>填表日期</th>
                                    <th>評估狀態</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                            {requestList.map((request) => (
                                <tr key={request.eva_id}>
                                    {editingRequest && editingRequest.eva_id === request.eva_id ? (
                                        <>
                                            <td colSpan={10}>
                                                <div className="container">
                                                    <div className="row g-1">
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請狀態</span>
                                                                <select
                                                                    className="form-select"
                                                                    name="status"
                                                                    value={updatedData.status}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    <option value="審核中">審核中</option>
                                                                    <option value="完成">完成</option>
                                                                    <option value="取消">取消</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary m-1" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td>{request.student_name}</td>
                                            <td>0{request.phone}</td>
                                            <td>{request.email}</td>
                                            <td>{request.area}</td>
                                            <td>{getOccupationLabel(request.occupation)}</td>
                                            <td>{getIndustryLabel(request.industry)}</td>
                                            <td>{getExperienceLabel(request.exp)}</td>
                                            <td>{getPurposeLabels(request.purpose)}</td>
                                            <td>{getSSNLabel(request.ssn)}</td>
                                            <td>{request.reason}</td>
                                            
                                            <td>
                                                {request.file ? (
                                                    <a
                                                    href={`${backend}${request.file}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >檢視文件</a>
                                                ) : (
                                                    "無"
                                                )}
                                            </td>
                                            <td>{dateHelper(request.create_time, "date")}</td>
                                            <td>{request.status}</td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={() => startEditing(request)}>
                                                    編輯
                                                </button>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                        </table>
                        {/* <div className="m-2 p-2">
                            {PageList(rowsCount, fetchData)}
                        </div> */}
                    </div>
                )}
            </div>
        </>
    );
}

export default EvaRequest;
